import { useQuery, useQueryClient } from "@tanstack/react-query";
import { batch, useDispatch, useSelector } from "react-redux";
import { ParticipantBffLearningApi } from "../../models/api";
import { Status } from "../../models/gameplan";
import { getParticipantLearningPath } from "../../services";
import { setActiveCourse } from "../slices/activeCourse";
import {
  getActiveLearningPath,
  setActiveLearningPath,
} from "../slices/activeLearningPath";

const ENDPOINT_URL = "/api/assessments/participant-bff/learning";

const onSuccess = (data: ParticipantBffLearningApi) => (dispatch) => {
  const { currentLearningPath, activeCourse } = data;

  batch(() => {
    dispatch(setActiveLearningPath(currentLearningPath.id));
    dispatch(setActiveCourse(activeCourse.id));
  });
};

export const useBffLearning = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const currentLearningPathId = useSelector(getActiveLearningPath);

  return useQuery({
    queryKey: [ENDPOINT_URL, currentLearningPathId],
    queryFn: () => getParticipantLearningPath(),
    onSuccess: (data: ParticipantBffLearningApi) => {
      if (!currentLearningPathId) {
        queryClient.setQueryData(
          [ENDPOINT_URL, data.currentLearningPath.id],
          data
        );
      }
      dispatch(onSuccess(data));
    },
  });
};

export const useUpdateBffLearning = () => {
  const queryClient = useQueryClient();
  const currentLearningPathId = useSelector(getActiveLearningPath);
  const bffLearningQueryKey = [ENDPOINT_URL, currentLearningPathId];

  const updateModuleStatus = (moduleId: number, status: Status) => {
    const cache: ParticipantBffLearningApi =
      queryClient.getQueryData(bffLearningQueryKey);

    if (!cache) return;

    const moduleToUpdateIndex = cache.activeCourse.modules.findIndex(
      (module) => module.id === moduleId
    );

    if (moduleToUpdateIndex > -1) {
      cache.activeCourse.modules[moduleToUpdateIndex].status = status;
    }

    queryClient.setQueryData(bffLearningQueryKey, cache);
  };

  return {
    updateModuleStatus,
  };
};
